import { render, staticRenderFns } from "./DeleteSvg.vue?vue&type=template&id=72de3b8a&"
import script from "./DeleteSvg.vue?vue&type=script&lang=js&"
export * from "./DeleteSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports